export default __webpack_public_path__ + "static/media/reqdone.51e9e3c3.svg";